import LoginVue from '../Login.vue'; import LoginVue from '../Login.vue'; import
LoginVue from '../Login.vue'; import LoginVue from '../Login.vue'; import
LoginVue from '../Login.vue'; import { onMounted } from 'vue';
<template>
  <main>
    <v-container fluid class="pa-5 pb-16 elevation-1">
      <!-- Título que abarca horizontalmente -->
      <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
        <h1 class="text-h4 font-weight-bold">
          Calendario de {{ this.nombre }}
        </h1>
      </v-sheet>

      <!-- Tabla de usuarios -->
      <v-card elevation="2" class="pa-4 mt-5">
        <v-card-text>
          <!-- Botón para abrir el DatePicker -->
          <v-row align="center">
            <v-col cols="auto">
              <p class="d-inline-block ma-3">
                <strong>Fecha Inicial:</strong> {{ formatDate(selectedDate) }}
              </p>
            </v-col>
            <!-- Botón para seleccionar la fecha inicial -->
            <v-col cols="auto">
              <v-btn
                color="primary"
                @click="dialog = true"
                class="ma-2"
                elevation="2"
              >
                <v-icon left>mdi-calendar</v-icon>
                Seleccionar Fecha Inicial
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <p class="d-inline-block ma-3 pa-3">
                <strong>Fecha Final:</strong> {{ formatDate(selectedEndDate) }}
              </p>
            </v-col>
            <!-- Botón para seleccionar la fecha final -->
            <v-col cols="auto">
              <v-btn
                color="secondary"
                @click="dialog1 = true"
                class="ma-2"
                elevation="2"
              >
                <v-icon left>mdi-calendar-check</v-icon>
                Seleccionar Fecha Final
              </v-btn>
            </v-col>
          </v-row>

          <!-- Dialogo que contiene el DatePicker -->

          <v-dialog v-model="dialog" persistent max-width="320">
            <v-card color="white" :max-width="cardMaxWidth">
              <v-date-picker
                color="#194c9b"
                v-model="selectedDate"
              ></v-date-picker>
              <v-card-actions>
                <!-- Botón Cerrar con fondo negro y texto oscuro -->
                <v-btn @click="dialog = false" color="black" class="text-dark">
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog1" persistent max-width="320">
            <v-card color="white" :max-width="cardMaxWidth">
              <v-date-picker
                color="#194c9b"
                v-model="selectedEndDate"
              ></v-date-picker>
              <v-card-actions>
                <!-- Botón Cerrar con fondo negro y texto oscuro -->
                <v-btn @click="dialog1 = false" color="black" class="text-dark">
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            color="success"
            @click="fechaData"
            :disabled="!selectedDate || !selectedEndDate"
            class="mt-4"
          >
            <v-icon left>mdi-database-search</v-icon> Consultar Datos
          </v-btn>
          <br />
          <v-data-table
            :headers="headers"
            :items="meetings"
            :items-per-page="5"
            class="elevation-1 pa-4"
            hover
            :loading="loading"
            item-value="id"
            show-expand
          >
            <!-- <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.descripcion }}</td>
                <td>{{ item.fecha }}</td>
                <td>{{ item.tiempo }}</td>
              </tr>
            </template> -->
            <!-- Fila expandida -->
            <template v-slot:expanded-row="{ item }">
              <tr>
                <td colspan="5">
                  <v-card flat class="pa-3">
                    <p>
                      <strong>Colaboradores Ivitados a Sesión:</strong>
                      {{ item.emails }}
                    </p>
                  </v-card>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-card class="pa-4 my-4" color="#194c9b" elevation="2">
            <v-card-title class="text-h6 font-weight-bold">
              Total de Horas en Sesión
            </v-card-title>
            <v-card-text class="text-h5"> {{ totalhoras }} hrs </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
  </main>
</template>

<script>
import api from "@/api/axios/axios.js";

export default {
  name: "DashUser",
  data() {
    return {
      meetings: [],
      nombre: "",
      dialog: false,
      dialog1: false,
      selectedDate: null,
      selectedEndDate: null,
      cardMaxWidth: "auto",
      email: "",
      totalhoras: 0,
      loading: false,
      headers: [
        { title: "ID", key: "id" },
        { title: "Descripción Meeting", key: "descripcion" },
        { title: "Fecha", key: "fecha" },
        { title: "Tiempo de Sesion (hrs)", key: "tiempo" },
        { title: "Detalle", key: "data-table-expand" },
      ],
    };
  },
  mounted() {
    this.nombre = this.$route.params.name;
    this.email = this.$route.params.email;
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      //   let date = new Date("2025-05-07");
      //   let formattedDate = date.toLocaleDateString("es-ES"); // Resultado: '07/05/2025'
      ////console.log(formattedDate);
      return new Date(date).toLocaleDateString("es-ES");
    },
    async fechaData() {
      if (!this.selectedDate || !this.selectedEndDate) {
        //console.log("Fechas no Seleccionadas");
      }
      const payload = {
        fecha_inicio: new Date(this.selectedDate).toLocaleDateString("es-ES"),
        fecha_fin: new Date(this.selectedEndDate).toLocaleDateString("es-ES"),
        email: this.email,
      };
      //console.log(this.email);
      //console.log(payload);
      this.loading = true;
      try {
        const response = await api.post(
          "/login/dataCalendarUser/",
          payload,
        );
        this.totalhoras = response.data[response.data.length - 1].tiempoTotal;
        this.meetings = response.data.map((u, index) => ({
          id: index + 1,
          descripcion: u.descripcion,
          fecha: u.fecha,
          tiempo: u.tiempo,
          emails: u.email,
        }));

        //console.log( this.meetings )
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
